"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const nprogress_1 = __importDefault(require("nprogress"));
const whiteList = ['/login', '/error/**']; // ant style wildcat
const frontGuard = function (to, from, next) {
    var _a, _b;
    nprogress_1.default.start();
    const auth = vue_1.default.prototype.$auth;
    // 白名单或未设置权限， 不验证
    if (onWhiteList(to.path) || (!((_a = to.meta) === null || _a === void 0 ? void 0 : _a.pid))) {
        next();
        return;
    }
    // 权限控制
    auth.access((_b = to.meta) === null || _b === void 0 ? void 0 : _b.pid).then((pass) => {
        // if (pass) {
        //   next()
        // } else {
        //   next({ path: '/error/403' })
        //   NP.done()
        // }
        // 暂时没有做权限控制
        next();
    }).catch(() => {
        nprogress_1.default.done();
    });
};
function onWhiteList(path) {
    const convertRegEx = (expr) => {
        return new RegExp('^' +
            (expr || '')
                .replace(/\*\*/g, '#__#')
                .replace(/\*/g, '[^/]*')
                .replace(/#__#/g, '.*') +
            '$');
    };
    return whiteList.some(v => convertRegEx(v).test(path));
}
exports.default = frontGuard;
